/**
* directives.paymentstatus Module
*
* Description
*/
var app = angular.module('directives.paymentstatus', []);

// require('./paymentstatus.directive.js');
require('./directives/printTemplate.directive.js');
// require('./directives/printTemplate.html');
// require('./index.html');

module.exports = app;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/paymentStatus/index.js
 ** module id = 209
 ** module chunks = 1
 **/